import React from "react";
import PropTypes from "prop-types";
import Typography from "@material-ui/core/Typography";

const styles = {
  card: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start",
    padding: 8,
    minWidth: 180,
    flexGrow: 100,
    border: "1px solid rgba(34, 96, 145, 0.15)",
    borderRadius: 4,
  },
  content: {
    display: "flex",
    flexDirection: "column",
    color: "#226091",
  },
  title: {
    fontSize: 16,
    fontWeight: 400,
  },
  value: {
    fontSize: 24,
    fontWeight: 600,
    color: '#284963'
  },
  iconWrapper: {
    margin: "0 18px",
  },
};

function OverviewCard({ icon, title, value }) {
  return (
    <div style={styles.card}>
      <div style={styles.iconWrapper}>{icon}</div>
      <div style={styles.content}>
        <div style={styles.title}>
          <Typography variant="body2">{title}</Typography>
        </div>
        <div style={styles.value}>
          <Typography variant="h6">{value}</Typography>
        </div>
      </div>
    </div>
  );
}

OverviewCard.defaultProps = {
  value: 0,
};

OverviewCard.propTypes = {
  icon: PropTypes.element.isRequired,
  title: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default OverviewCard;
